import api from "@/services/api";
import axios from "axios";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

export default {
  fetchUsers() {
    return api.get(`users/`).then(response => response.data);
  },
  userLookUp(payload) {
    return api.post(`users/look_up_user/`, payload);
  },
  updateUser(payload) {
    return api.patch(`users/${payload.pk}/`, payload);
  },
  getToken() {
    return axios.get(process.env.VUE_APP_ARCGIS_TOKEN_URL, {
      params: {
        client_id: process.env.VUE_APP_ARCGIS_ID,
        grant_type: "client_credentials",
        client_secret: process.env.VUE_APP_ARCGIS_SECRET,
        f: "pjson"
      }
    });
  },
  createGeocode(payload) {
    return this.getToken()
      .then(response => {
        const accessToken = response.data.access_token;
        let address = {
          records: [
            {
              attributes: {
                OBJECTID: 1,
                Address: payload.address,
                City: payload.city,
                Region: payload.state,
                Postal: payload.postalCode
              }
            }
          ]
        };

        let formattedAddress = encodeURI(JSON.stringify(address));
        return axios
          .get(
            process.env.VUE_APP_ARCGIS_GEOCODE_URL +
              "addresses=" +
              formattedAddress,
            {
              params: {
                forStorage: true,
                token: accessToken,
                f: "pjson"
              }
            }
          )
          .then(response => {
            return response.data.locations[0].location;
          });
      })
      .catch(error => {
        /* eslint-disable */
        console.log(error);
        /* eslint-enable */
        // Will change to formal warning later
      });
  },
  emailAllUsers(payload) {
    return api.post(`users/send_emails/`, payload);
  },
  notifyAdmin(payload) {
    return api.post(`users/notify_admin/`, payload);
  },
  getUserNames() {
    return api.get(`users/get_user_names`)
  }
};
